class Recall extends window.HTMLElement {
    constructor() {
        super();
        this.toggles = Array.from(this.querySelectorAll('[data-toggle]'));
        this.recallsDetails =  Array.from(this.querySelectorAll('[data-recall-id]'));
        this.recallTable = this.querySelector('[data-recall-table]');
        this.back =  Array.from(this.querySelectorAll('[data-back]'));
    }

    connectedCallback() {
        this.toggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                this.findRecall(toggle.getAttribute('data-toggle')) 
            });
        });
        this.back.forEach(back => {
            back.addEventListener('click', () => {
                this.recallTable.classList.remove('hidden');
                this.recallsDetails.forEach(detail => detail.classList.add('hidden'));
            });
        });
    }

    findRecall(id) {
       const recall = this.recallsDetails.find(detail => detail.getAttribute('data-recall-id') === id);
        if (recall) {
            recall.classList.remove('hidden');
            this.recallTable.classList.add('hidden');
        }
    }
  
}

window.customElements.define('recall-details', Recall);